import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './SuperAdminsList.css';

const ViewMasterForm = () => {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchForm();
  }, [id]);

  const fetchForm = async () => {
    try {
      const response = await axios.get(`/api/forms/${id}`);
      setForm(response.data);
    } catch (error) {
      console.error('Failed to fetch form:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!form) {
    return <div>Form not found</div>;
  }

  return (
    <div className="superadmins-list">
      <div className="page-header">
        <h2>{form.form_name}</h2>
        <button onClick={() => navigate('/superadmin/forms')} className="btn-secondary">Back to Forms</button>
      </div>

      <div style={{ background: 'white', padding: '2rem', borderRadius: '8px' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <h3>Form Details</h3>
          <p><strong>Description:</strong> {form.form_description || 'No description'}</p>
          <p><strong>Status:</strong> {form.is_active ? 'Active' : 'Inactive'}</p>
          <p><strong>Created:</strong> {new Date(form.created_at).toLocaleString()}</p>
          {form.updated_at && (
            <p><strong>Last Updated:</strong> {new Date(form.updated_at).toLocaleString()}</p>
          )}
        </div>

        <div className="form-actions">
          <button onClick={() => navigate(`/superadmin/forms/edit/${id}`)} className="btn-primary">Edit Form</button>
        </div>
      </div>
    </div>
  );
};

export default ViewMasterForm;




